import { booleanAttribute, Component, effect, input, numberAttribute } from '@angular/core';
import { Step2SimpleComponent } from 'src/app/components/consulting-reservation/step2-simple/step2.component';


@Component({
  selector: 'app-request-material',
  imports: [
    Step2SimpleComponent
  ],
  templateUrl: './request-material.html',
  styleUrl: './request-material.scss'
})
export class RequestMaterial {
  readonly lpType = input<string | null>(null);
  readonly discount = input(10, { transform: numberAttribute });
  readonly isCasual = input(false, { alias: 'casual', transform: booleanAttribute });

  readonly cvButtonText = input('', { alias: 'cv-button' });
  readonly topText = input('', { alias: 'cv-button-top' });

  readonly completeUrl = input<string>('');

  constructor() {
    if (!sessionStorage.getItem('counseling')) {
      sessionStorage.setItem('counseling', JSON.stringify({}));
    }

    effect(() => {
      const lpType = this.lpType();
      if (lpType) {
        const data = JSON.parse(sessionStorage.getItem('counseling') ?? '{}');
        data.lpType = lpType;
        data.isCasual = this.isCasual();
        sessionStorage.setItem('counseling', JSON.stringify(data));
      }
    });
  }

  protected next() {
    localStorage.removeItem('reservedAt');
    window.location.href = this.completeUrl();
  }
}
